import Swiper from 'swiper/bundle';


document.addEventListener('DOMContentLoaded', async function () {

    var swiper2 = new Swiper(".managers-slider", {
        direction: "horizontal",
        slidesPerView: 1.2,
        slideToClickedSlide: false,
        spaceBetween: 20,
        loop: true,
        navigation: {

            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            1024: {
                slidesPerView: 4,
                slideToClickedSlide: false,
                spaceBetween: 24,
            }
        }
    });
});

if (window.innerWidth > 1024) {
    let activeSection = null;

    function resetActiveSection() {
        if (activeSection) {
            const hideSection = activeSection.querySelector('.hide-section');
            hideSection.classList.remove('show');
            hideSection.classList.add('hide');
            activeSection.style.transform = 'translateY(0) translateX(0)';

            document.querySelector('.missions-wrapper .section:nth-of-type(2)').style.transform = 'translateX(0)';
            document.querySelector('.missions-wrapper .section:nth-of-type(4)').style.transform = 'translateX(0)';
            document.querySelector('.missions-wrapper .section:nth-of-type(5)').style.transform = 'translateY(0)';
            document.querySelector('.missions-wrapper .section:nth-of-type(6)').style.transform = 'translateY(0)';

            activeSection = null;
        }
    }

    function animateSection(section) {
        const hideSection = section.querySelector('.hide-section');
        const sectionIndex = Array.from(section.parentNode.children).indexOf(section) + 1;

        section.style.transition = 'all 0.5s ease-in-out';
        hideSection.style.transition = 'all 0.5s ease-in-out';

        hideSection.classList.remove('hide');
        hideSection.classList.add('show');

        switch (sectionIndex) {
            case 2:
                document.querySelector('.missions-wrapper .section:nth-of-type(4)').style.transform = 'translateX(-100%)';
                break;
            case 4:
                section.style.transform = 'translateY(-100%)';
                document.querySelector('.missions-wrapper .section:nth-of-type(2)').style.transform = 'translateX(-100%)';
                break;
            case 5:
                section.style.transform = 'translateY(-100%)';
                break;
            case 6:
                section.style.transform = 'translateY(-100%)';
                document.querySelector('.missions-wrapper .section:nth-of-type(4)').style.transform = 'translateX(-100%)';
                break;
        }

        activeSection = section;
    }

    document.querySelectorAll('.missions .section').forEach(section => {
        section.addEventListener('click', function () {
            if (activeSection === this) {
                resetActiveSection();
            } else {
                resetActiveSection();
                animateSection(this);
            }
        });
    });
}
